export { default } from './MainHero';
